import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth API
export const authAPI = {
  login: async (email, password) => {
    const response = await axios.post(`${API_BASE}/auth/login`, { email, password });
    return response.data;
  },
  
  verify: async (token) => {
    const response = await axios.get(`${API_BASE}/auth/verify`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

// Booking API
export const bookingAPI = {
  create: async (bookingData) => {
    const response = await axios.post(`${API_BASE}/bookings`, bookingData);
    return response.data;
  },
  
  getAll: async (token) => {
    const response = await axios.get(`${API_BASE}/bookings`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  updatePayment: async (id, paymentData) => {
    const response = await axios.patch(`${API_BASE}/bookings/${id}/payment`, paymentData);
    return response.data;
  },

  createManual: async (bookingData, token) => {
    const response = await axios.post(`${API_BASE}/bookings/manual`, bookingData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  markComplete: async (id, token) => {
    const response = await axios.patch(`${API_BASE}/bookings/${id}/complete`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getBlockedSlots: async (date) => {
    const response = await axios.get(`${API_BASE}/bookings/blocked-slots`, { params: { date } });
    return response.data;
  }
};

// Purchase API
export const purchaseAPI = {
  create: async (purchaseData) => {
    const response = await axios.post(`${API_BASE}/purchases`, purchaseData);
    return response.data;
  },
  
  getAll: async (token) => {
    const response = await axios.get(`${API_BASE}/purchases`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  updatePayment: async (id, paymentData) => {
    const response = await axios.patch(`${API_BASE}/purchases/${id}/payment`, paymentData);
    return response.data;
  }
};
